import { ThinUploadModal } from "./ThinUploadModal";

export function UploadGoodsReceiptModal({
  open, onOpenChange,
}: { open: boolean; onOpenChange: (v: boolean) => void }) {
  return (
    <ThinUploadModal
      open={open}
      onOpenChange={onOpenChange}
      title="Goods Receipt"
      entityType="goods_receipt"
      extractEndpoint="/goods-receipts/extract"
      detailRoutePrefix="/goods-receipts"
    />
  );
}
